import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, catchError, delay, map, retry, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { BillingModel } from './api.billing.model';

const BILLING_PATH = {
  socPoint: '/socpoint'
};

export class BillingApi {
  private apiUrl: string = environment.API_URL;

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getSocPointTransactions(
    params: BillingModel.GetSocPointTransactionParams
  ): Observable<BillingModel.SocPointTransactionsRes> {
    let httpParams = new HttpParams();
    (Object.keys(params) as (keyof BillingModel.GetSocPointTransactionParams)[]).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    return this.http
      .get<BillingModel.SocPointTransactionsRes>(`${this.apiUrl}${BILLING_PATH.socPoint}/bill`, {
        params: httpParams
      })
      .pipe(
        delay(200),
        retry(1),
        timeout(this.config.responseTimeout),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
